// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2hQkd","icon":"index_icon_2OxXR"};